import React from 'react';
import { Container, ToggleButton, ButtonGroup } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-scroll';
import useLocalize from '../../common/intl/useLocalize';
import { changeLocale, useIntlData } from '../../common/intl/changeLocale';
import useDevice from '../../common/device/useDevice';
import { DEFAULT_DELAY, DEFAULT_DURATION } from '../../common/constants';

const LANGUAGES = [
  {
    value: 'ru',
    label: 'Русский',
  },
  {
    value: 'en',
    label: 'English',
  },
];

const Header = () => {
  const localize = useLocalize();
  const { isDesktop, isMobile } = useDevice();
  const intlData = useIntlData();
  const handleChangeLocale = React.useCallback(
    (e) => {
      changeLocale(e.currentTarget.value);
    },
    [changeLocale]
  );

  return (
    <section id="hero" className="jumbotron">
      <ButtonGroup
        className="language-switcher"
        toggle
        aria-label={localize('firstPage-language-aria-label')}
      >
        {LANGUAGES.map(({ label, value }) => (
          <ToggleButton
            key={value}
            onChange={handleChangeLocale}
            checked={value === intlData.locale}
            type="radio"
            value={value}
            variant="secondary"
          >
            {label}
          </ToggleButton>
        ))}
      </ButtonGroup>
      <Container>
        <Fade
          left={isDesktop}
          bottom={isMobile}
          duration={DEFAULT_DURATION}
          delay={DEFAULT_DELAY}
          distance="30px"
        >
          <h1 className="hero-title">
            {localize('firstPage-title')}{' '}
            <span className="text-color-main">{localize('firstPage-name')}</span>
            <br />
            {localize('firstPage-subtitle')}
          </h1>
        </Fade>
        <Fade
          left={isDesktop}
          bottom={isMobile}
          duration={DEFAULT_DURATION}
          delay={DEFAULT_DELAY * 2}
          distance="30px"
        >
          <p className="hero-cta">
            <span className="cta-btn cta-btn--hero">
              <Link to="about" smooth duration={DEFAULT_DURATION}>
                {localize('firstPage-knowMore')}
              </Link>
            </span>
          </p>
        </Fade>
      </Container>
    </section>
  );
};

export default Header;
